import { render, staticRenderFns } from "./ProductContent.vue?vue&type=template&id=71c4fcd2&scoped=true&"
import script from "./ProductContent.vue?vue&type=script&lang=js&"
export * from "./ProductContent.vue?vue&type=script&lang=js&"
import style0 from "./ProductContent.vue?vue&type=style&index=0&id=71c4fcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c4fcd2",
  null
  
)

export default component.exports